import React from 'react'
import { Select } from '../index'
import Flag from '../../../components/Template/Flag'
import { ISelectInputProps } from '../Select/Select'
import { countryCodes } from '../../../i18n/countryCodes'

const CountrySelect = ({
  countryDictionary,
  isUniCountry,
  countryValue = 'id',
  ...rest
}: ICountrySelectProps) => {
  function optionWithFlags(country) {
    const flag = (
      <Flag countryCode={country.code.toLowerCase()} width={16} height={16} />
    )

    return (
      <Select.Option
        key={country[countryValue]}
        value={Number(country[countryValue]) || country[countryValue]}
        icon={flag}
      >
        {country.name}
      </Select.Option>
    )
  }

  const countries = countryDictionary.filter(
    country =>
      !isUniCountry ||
      (countryCodes as string[]).includes(country.code.toLowerCase()),
  )

  return (
    <Select.ReduxField {...rest}>
      {countries && countries.map(country => optionWithFlags(country))}
    </Select.ReduxField>
  )
}

export default CountrySelect

export interface ICountrySelectProps extends ISelectInputProps {
  countryDictionary: {
    id: string
    name: string
    code: string
  }[]
  isSmallReservation?: boolean
  isUniCountry?: true
  countryValue?: 'id' | 'code'
}

export { CountrySelect }
